// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-Author-styles---container---3O6Eg","label":"_-src-components-Author-styles---label---PNB1a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Author/styles.css
// module id = 784
// module chunks = 0